import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Field from 'redux-form/lib/Field';
import { Link as ReactRouterDOMLink } from 'react-router-dom';
import reduxForm from 'redux-form/lib/reduxForm';

import ButtonWithHoverAndPress from '../../shared/Button/ButtonWithHoverAndPress';
import Captcha from '../Captcha';
import FieldFormGroup from '../FieldFormGroup';
import Box from '../../shared/Box';
import { LinkText } from '../../shared/Link';
import ErrorAlert from './components/ErrorAlert';
import events from '../SignupPageContainer/events';

import {
  EXISTING_ACCOUNT_ERROR_MESSAGE,
  EXISTING_EMAIL_ERROR_MESSAGE,
  validate,
} from '../../user';
import styles from '../OnboardingRouter/styles.sass';

const INPUT_FIELDS = [
  {
    name: 'name',
    placeholder: 'Full Name',
    type: 'text',
  },
  {
    name: 'email',
    placeholder: 'Email',
    type: 'email',
  },
  {
    name: 'password',
    placeholder: 'Password',
    type: 'password',
  },
];

// This is currently built only for onboarding
class SignupForm extends Component {
  handleClickRequestResetPassword = evt => {
    const { onClickRequestResetPassword } = this.props;
    onClickRequestResetPassword();
  };

  loginUrl = () => {
    const { feedUrl } = this.props;
    return `/login${feedUrl ? `?feedUrl=${encodeURIComponent(feedUrl)}` : ''}`;
  };

  render() {
    const { error, handleSubmit, submitting, invalid } = this.props;
    return (
      <form onSubmit={handleSubmit} id="form1">
        <div className={styles.podcastNameField}>
          {INPUT_FIELDS.map(field => (
            <Field
              name={field.name}
              placeholder={field.placeholder}
              component={FieldFormGroup}
              type={field.type}
              key={field.name}
            />
          ))}
          <Field name="captcharesponse" component={Captcha} />
        </div>
        <Box marginBottom={8}>
          <ButtonWithHoverAndPress
            colorTheme="primary"
            isDisabled={submitting || invalid}
            isProcessing={submitting}
            isFullWidth
            size="md"
            shape="pill"
            text="Sign up"
            type="unelevated"
            typeAttribute="submit"
            isEventBubblingAllowed
            onPress={events.signUpRegisterButtonClicked}
          />
        </Box>
        <div className={styles.terms}>
          By continuing, you agree to our{' '}
          <LinkText
            onClick={() => events.signUpLegalLinkClicked({ link: 'tos' })}
            isInline
            to="/tos"
          >
            Terms of Service
          </LinkText>{' '}
          and{' '}
          <LinkText
            onClick={() => events.signUpLegalLinkClicked({ link: 'privacy' })}
            isInline
            to="/privacy"
          >
            Privacy Policy
          </LinkText>
          .
        </div>
        {error &&
          (() => {
            switch (error) {
              case EXISTING_ACCOUNT_ERROR_MESSAGE:
                return (
                  <ErrorAlert
                    title="Existing account found"
                    renderMessage={
                      <React.Fragment>
                        We found an existing account that uses these
                        credentials. You can{' '}
                        <ReactRouterDOMLink
                          to={this.loginUrl()}
                          onClick={() => events.signUpSignInButtonClicked()}
                        >
                          log in
                        </ReactRouterDOMLink>{' '}
                        ‌or try again with a different email address.
                      </React.Fragment>
                    }
                  />
                );
              case EXISTING_EMAIL_ERROR_MESSAGE:
                return (
                  <ErrorAlert
                    title="This email address is already being used"
                    renderMessage={
                      <React.Fragment>
                        We found an existing account with this email address,
                        but this password doesn’t match. You can try again or{' '}
                        <ReactRouterDOMLink
                          to={this.loginUrl()}
                          onClick={this.handleClickRequestResetPassword}
                        >
                          reset your password
                        </ReactRouterDOMLink>
                        .
                      </React.Fragment>
                    }
                  />
                );
              default:
                return (
                  <ErrorAlert
                    title="Unable to create account"
                    renderMessage={
                      <React.Fragment>
                        Sorry, but we were unable to create your account. Please
                        refresh the page and try again, or visit{' '}
                        <LinkText to="https://help.anchor.fm/hc/en-us" isInline>
                          help.anchor.fm
                        </LinkText>{' '}
                        so we can help you troubleshoot.
                      </React.Fragment>
                    }
                  />
                );
            }
          })()}
      </form>
    );
  }
}

SignupForm.propTypes = {
  error: PropTypes.string,
  feedUrl: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  onClickRequestResetPassword: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

SignupForm.defaultProps = {
  error: undefined,
  feedUrl: '',
};

export default reduxForm({
  form: 'createAccount',
  validate,
})(SignupForm);
